(() => {
  const init = (root = document) => root.querySelectorAll('[data-minbie-finder]').forEach(finder => {
    if (finder.dataset.ready) return;
    finder.dataset.ready = 'true';
    finder.addEventListener('change', event => {
      if (!event.target.matches('input[type="radio"]')) return;
      finder.querySelectorAll('[data-finder-result]').forEach(result => {
        const active = result.dataset.finderResult === event.target.value;
        result.hidden = !active;
        result.classList.toggle('is-active', active);
      });
    });
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
